import React from 'react';
import { InstagramIcon, FacebookIcon, YoutubeIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-ink border-t border-gold/15 py-12" data-id="element-109">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-8 items-center" data-id="element-110">
        <div data-id="element-111">
          <div className="font-display text-3xl tracking-[0.2em] gold-text mb-2" data-id="element-112">
            JADE
          </div>
          <p className="text-cream/50 text-sm" data-id="element-113">Latin Music · Orlando, FL</p>
        </div>
        <p className="text-cream/60 text-sm md:text-center font-display italic" data-id="element-114">
          {t('footer.tagline')}
        </p>
        <div className="flex gap-3 md:justify-end" data-id="element-115">
          {[{
          icon: InstagramIcon,
          href: 'https://instagram.com/jademusic'
        }, {
          icon: FacebookIcon,
          href: '#'
        }, {
          icon: YoutubeIcon,
          href: '#'
        }, {
          icon: PhoneIcon,
          href: 'tel:+14077707625'
        }].map((s, i) => {
          const Icon = s.icon;
          return <a key={i} href={s.href} className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors" data-id="element-116">
                <Icon size={16} data-id="element-117" />
              </a>;
        })}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-10 pt-6 border-t border-gold/10 text-center text-cream/40 text-xs" data-id="element-118">
        © {new Date().getFullYear()} Jade Latin Music. {t('footer.rights')}
      </div>
    </footer>;
}